import  {
    REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST,
    VALIDATE_CHANGE_ACTIVITY_ASSIGNEE,
    BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST,
    FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST
} from '../SpockViewPage/actions/actionConstants';

import { BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST } from '../../components/ChangeOwner/actionConstants';

import AppConstants from '../../config/appConstants';


const mappingObject = {};

mappingObject[REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST] = {
    url:'/reassactfrmvw',
    mockdata: 'reassactfrmvw.json',
    method:AppConstants.httpMethod.POST
}

mappingObject[VALIDATE_CHANGE_ACTIVITY_ASSIGNEE] = {
    url:'/gtvalidchngactassigneeintra',
    mockdata: 'gtvalidchngactassigneeintra.json',
    method:AppConstants.httpMethod.POST
}

mappingObject[BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST] = {
    url:'/blkchngactassignee',
    mockdata: 'blkchngactassignee.json',
    method:AppConstants.httpMethod.POST
}

mappingObject[BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST] = {
    url: '/ActivityAction/GetValidActivitiesForChangeOwner',
    mockdata : '',
    method: AppConstants.httpMethod.POST
}

mappingObject[FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST] = {
    url:'/blkactreassignusrs',
    mockdata: 'blkactreassignusrs_single.json',
    method: AppConstants.httpMethod.GET
};

export default mappingObject;